import { render, staticRenderFns } from "./SpacingPlaygroud.vue?vue&type=template&id=f23631aa&"
import script from "./SpacingPlaygroud.vue?vue&type=script&lang=js&"
export * from "./SpacingPlaygroud.vue?vue&type=script&lang=js&"
import style0 from "./SpacingPlaygroud.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports